import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { PrivateAppEdit } from "./editPrivateApp";
import { TPIService } from "../../base/tpiService";
import { Dropdown, Menu, Modal, Button } from "antd";
import { PrivateAppCreate } from "./createPrivateApp";
import { initialStateModel } from "../../models/model";
import threedot from "../../styles/images/threedotimgg.svg";
import styles from "../privateapp/scss/privateapp.module.scss";
import { toastInformation } from "../../base/callService/common";
import profimg from "../../../src/styles/images/iconvariation (1).svg";


type privateAppState = {
  appList: Array<any>;
  selectedAppData: any;
  isTokenCopied: boolean;
  isTokenModal: boolean;
  isCreateModal: boolean;
  isEdit: boolean;
  isDelete: boolean;
  deleteParticulardata: any;
};

function Privateappindex() {
  const { loginReducer }: initialStateModel = useSelector(
    (state: initialStateModel) => state
  );

  const [getPrivApp, setPrivApp] = useState<privateAppState>({
    appList: [],
    selectedAppData: {},
    isTokenCopied: false,
    isTokenModal: false,
    isCreateModal: false,
    isEdit: false,
    isDelete: false,
    deleteParticulardata: {}
  });

  const viewAccessToken = (particularData: any) => {
    setPrivApp({
      ...getPrivApp,
      selectedAppData: particularData,
      isTokenCopied: false,
      isTokenModal: !getPrivApp.isTokenModal
    });

  };

  const deletePrivateApp = (data: any) => {
    setPrivApp({ ...getPrivApp, isDelete: !getPrivApp.isDelete, deleteParticulardata: data });
  }

  const copyToken = () => {
    setPrivApp({ ...getPrivApp, isTokenCopied: true });
    navigator.clipboard.writeText(getPrivApp.selectedAppData.token).then(() => {
      toastInformation('Access token copied to clipboard!', 'success')
    })
      .catch((error) => {
        console.error("Failed to copy code snippet: ", error);
      });
  }

  const callPrivateAPPList = async () => {
    const payload = {
      domainId: loginReducer.userdetails.domain_id,
      typeOfApp: 0,
      productType: "ucaas",
      sipLoginId: loginReducer.userdetails.sip_login_id
    };
    
    let response = await TPIService.getPrivatAppList(payload);
    if (response.statusCode === 200) {
      setPrivApp({ ...getPrivApp, appList: response.result, isDelete: false });
    } else {
      console.log("errr getPrivatAppList------------------");
    }
  };

  const confirmDeleteApp = async () => {
    try {
      let endpoint = `deleteApp/${getPrivApp.deleteParticulardata.appId}`
      let response = await TPIService.deletePrivateApp(endpoint);
      if (response.statusCode === 200) {
        toastInformation('App deleted Successfully', 'success')
        callPrivateAPPList();
      }
      else {
        toastInformation(response.message, 'success')
      }
    } catch (err) {
      console.log("err in confirmDeleteApp-----", err)
    }
  }

  useEffect(() => {
    if(!getPrivApp.isCreateModal && !getPrivApp.isEdit)
    {
     callPrivateAPPList();
    }
  }, [!getPrivApp.isCreateModal, !getPrivApp.isEdit]);

  const createPrivApp = () => {
    setPrivApp({ ...getPrivApp, isCreateModal: !getPrivApp.isCreateModal });
  };

  const editApp = () => {
    setPrivApp({ ...getPrivApp, isEdit: !getPrivApp.isEdit });
  };

  const selectedAppEditDet = async (particularData: any) => {

    let response: any = await TPIService.privateAppDetails(particularData.appId);
    if (response.statusCode === 200) {
      response.result.scopeID = response.result.scopeID.toString().split(',');
      setPrivApp({ ...getPrivApp, selectedAppData: response.result, isEdit: true });
    }
  }

  return (
    <div>
      <div className={styles.privateappindexbodyy}>
        <div className={styles.createprivateappsec}>
          <div className={styles.contenttext}>
            <h5>Private App</h5>
            <p>
              Users can allow other applications to retrieve information using
              an API token key.
            </p>
          </div>
          <div className={styles.rightbtn}>
            <button onClick={createPrivApp}>Create Private App</button>
          </div>
        </div>
      </div>

  
      <Modal
        centered
        visible={getPrivApp.isTokenModal}
        title="Access token"
        onCancel={() => setPrivApp({ ...getPrivApp, isTokenModal: !getPrivApp.isTokenModal })}
        className="Accesstokenmodal"
        maskClosable={false}
        footer={[
          <>
            <div>
              <Button key="cancel" className="secondarybutton" onClick={viewAccessToken}>
                Cancel
              </Button>
              <Button key="copy" className={getPrivApp.isTokenCopied ? `${styles.primarybutton} ${styles.disabled}` : styles.primarybutton} onClick={copyToken}>
                Copy Token
              </Button>
              {/* <Button key="trim" className="primarybutton" >Next</Button> */}
            </div>
          </>
        ]}
      >
        <div>
          <div className={styles.accesstokenbody}>
            <p>{getPrivApp.selectedAppData.token}</p>
          </div>
        </div>
      </Modal>

      <Modal
        centered
        visible={getPrivApp.isDelete}
        title="Delete App"
        onCancel={() => setPrivApp({ ...getPrivApp, isDelete: !getPrivApp.isDelete })}
        className="DeleteAppmodal"
        maskClosable={false}
        footer={[
          <>
            <div>
              <Button key="cancel" className="secondarybutton" onClick={() => setPrivApp({ ...getPrivApp, isDelete: !getPrivApp.isDelete })}>
                Cancel
              </Button>
              <Button key="trim" className={styles.primarybutton} onClick={confirmDeleteApp}>
                Delete
              </Button>
            </div>
          </>
        ]}
      >
        <div>
          <div className={styles.deleteappmodalcontent}>
            <p>
              {" "}
              Deleting the private app will erase all your data and expires its
              access token. This can’t be done.
            </p>
          </div>
        </div>
      </Modal>

      {/* <div className=" popupmodal">
      <div className="popupmodalblock">
    
        
        <div>
          <div className="privateappcustomtab">
            <div className="header">
              <h5> App Name</h5>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M9.20074 8.00101L15.0557 2.14551C15.3877 1.81441 15.3877 1.27541 15.0557 0.944312C14.7237 0.612312 14.1846 0.612312 13.8545 0.944312L7.99954 6.79971L2.14454 0.944312C1.81444 0.612312 1.27344 0.612312 0.943336 0.944312C0.611336 1.27541 0.611336 1.81441 0.943336 2.14551L6.79834 8.00101L0.943336 13.8565C0.611336 14.1876 0.611336 14.7266 0.943336 15.0577C1.10934 15.2237 1.32614 15.3067 1.54394 15.3067C1.76174 15.3067 1.97944 15.2237 2.14454 15.0577L7.99954 9.20231L13.8545 15.0577C14.0195 15.2237 14.2373 15.3067 14.4551 15.3067C14.6729 15.3067 14.8897 15.2237 15.0557 15.0577C15.3877 14.7266 15.3877 14.1876 15.0557 13.8565L9.20074 8.00101Z" fill="#757676"/>
</svg>
            </div>
            <div className="privatecustormmodalbody">


             <Tabs defaultActiveKey="1" centered className="TopNavBtn" >
              <TabPane tab="App Info" key="1">
                    <div>
                    <div className={styles.stepperinputbdy}>
            <div className={styles.createformblock}>
              <label>
                Name <span>*</span>
              </label>
              <input
                type="text"
                name="categoryname"
                placeholder="Worktual Test App"
                  className=" heightcorectioninput"
              />
            </div>
            <div className={styles.createformblock}>
              <label>
                Description<span>*</span>
              </label>
              <textarea
                name="categoryname"
                placeholder="Select what occurs after someone gets your email. You can include as many steps as required."
              />
            </div>
          </div>
                    </div>
              </TabPane>
              <TabPane tab="Scope" key="2" className="TopNavBtn">
                  <div> 
                  <div className={styles.checklistsection}>
            <div className={styles.checklistrow}>
              <div className={styles.checklisttext}>
                <p>crm.lists</p>
              </div>
              <div className={styles.checkboxflexcon}>
                <label className="switch">
                  <input type="checkbox" name="checkbox" className="checkbox" />
                </label>
                <label className="switch">
                  <input type="checkbox" name="checkbox" />
                </label>
              </div>
            </div>
            <div className={styles.checklistrow}>
              <div className={styles.checklisttext}>
                <p>crm.lists</p>
              </div>
              <div className={styles.checkboxflexcon}>
                <label className={styles.switch}>
                  <input type="checkbox" name="checkbox" className="checkbox" />
                </label>
                <label className="switch">
                  <input type="checkbox" name="checkbox" />
                </label>
              </div>
            </div>
            <div className={styles.checklistrow}>
              <div className={styles.checklisttext}>
                <p>crm.lists</p>
              </div>
              <div className={styles.checkboxflexcon}>
                <label className="switch">
                  <input type="checkbox" name="checkbox" className="checkbox" />
                </label>
                <label className="switch">
                  <input type="checkbox" name="checkbox" />
                </label>
              </div>
            </div>
            <div className={styles.checklistrow}>
              <div className={styles.checklisttext}>
                <p>crm.lists</p>
              </div>
              <div className={styles.checkboxflexcon}>
                <label className="switch">
                  <input type="checkbox" name="checkbox" className="checkbox" />
                </label>
                <label className="switch">
                  <input type="checkbox" name="checkbox" />
                </label>
              </div>
            </div>
            <div className={styles.checklistrow}>
              <div className={styles.checklisttext}>
                <p>crm.lists</p>
              </div>
              <div className={styles.checkboxflexcon}>
                <label className="switch">
                  <input type="checkbox" name="checkbox" className="checkbox" />
                </label>
                <label className="switch">
                  <input type="checkbox" name="checkbox" />
                </label>
              </div>
            </div>
          </div>
                  </div>
              </TabPane>
            </Tabs>
            </div>
            <div className="privatecustormmodalfooter">
              <div className={styles.footerbottomnew}>
              <div className={styles.footerbottomnewbtnsec}>
                 <Button key="cancel"  className= {styles.secondarybutton}>Back</Button>
                <Button key="trim" className= {styles.primarybutton }>Next</Button>
             </div>
             <div>
               <a>Cancel</a>
             </div>
             </div>
            </div>


            </div>

               
        
        </div>
      


  
      </div>
      </div> */}


      <div className={styles.settingssection}>
        {getPrivApp.appList.map((data, index) => {

          return (
            <div className={styles.stngsrow} key={index}>
              <div className={styles.frstcol}>
                <div className={styles.frstcoltxtcon}>
                  <div className={styles.profimgdiv}>
                    <img src={profimg} />
                  </div>
                  <div className={styles.txtdivv}>
                    <h5>{data.name}</h5>
                    <p>{data.description}</p>
                  </div>
                </div>
              </div>
              <div className={styles.scndcol}>
                {/* <img src={threedot}/> */}
                <Dropdown
                  overlay={
                    <>
                      <div className={styles.dropdownmenu}>
                        <h3 onClick={() => viewAccessToken(data)}>
                          View access token
                        </h3>
                        <h3 onClick={() => selectedAppEditDet(data)}>Edit</h3>
                        <h3 onClick={() => deletePrivateApp(data)}>Delete</h3>
                      </div>
                    </>
                  }
                  trigger={["click"]}
                  onClick={(e: any) => e.stopPropagation()}
                >
                  <img src={threedot} />
                </Dropdown>
              </div>
            </div>
          );
        })}
      </div>
      {getPrivApp.isCreateModal && (<PrivateAppCreate closeModal={createPrivApp} />)}
      {getPrivApp.isEdit && (<PrivateAppEdit closeModal={editApp} selectedApp={getPrivApp.selectedAppData} />)}
    </div>
  );
}

export default Privateappindex;
